var _defs, _circle, _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack357({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8.03,
    r: 7.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.5,
    y: 5.94,
    width: 9.29,
    height: 4.17
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "11.13 8.03 14.5 9.97 14.5 6.08 11.13 8.03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack357);
export default __webpack_public_path__ + "static/media/Symbol_pack_357.8e3ada9b6e1ba83da2f73140fd6ffd2f.svg";
export { ForwardRef as ReactComponent };